<template>
    <v-container
        v-if="title || subtitle"
        fluid
        class="py-0"
    >
        <div class="menu-page mt-6 mb-2">
            <page-hero
                :title="title"
                :subtitle="subtitle"
            />
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'AppSubheader',
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        }
    },
}
</script>
